(function ($) {
  "use strict";

  var $window = $(window),
    $body = $("body");

  $(document).ready(function() {

    /*---------------------------------
                Off Canvas toggler Function
            -----------------------------------*/

    var $offCanvasToggle = $(".offcanvas-toggle"),
      $offCanvas = $(".offcanvas"),
      $offCanvasOverlay = $(".offcanvas-overlay"),
      $mobileMenuToggle = $(".mobile-menu-toggle");
    $offCanvasToggle.on("click", function (e) {
      e.preventDefault();
      var $this = $(this),
        $target = $this.attr("href");
      $body.addClass("offcanvas-open");
      $($target).addClass("offcanvas-open");
      $offCanvasOverlay.fadeIn();

      if ($this.parent().hasClass("mobile-menu-toggle")) {
        $this.addClass("close");
      }
    });
    $(".offcanvas-close, .offcanvas-overlay").on("click", function (e) {
      e.preventDefault();
      $body.removeClass("offcanvas-open");
      $offCanvas.removeClass("offcanvas-open");
      $offCanvasOverlay.fadeOut();
      $mobileMenuToggle.find("a").removeClass("close");
    });

    /*----------------------------------
               Off Canvas Menu
           -----------------------------------*/

    function mobileOffCanvasMenu() {
      var $offCanvasNav = $(".offcanvas-menu, .overlay-menu"),
        $offCanvasNavSubMenu = $offCanvasNav.find(".offcanvas-submenu");
      /*Add Toggle Button With Off Canvas Sub Menu*/

      $offCanvasNavSubMenu.parent().prepend('<span class="menu-expand"></span>');
      /*Category Sub Menu Toggle*/

      $offCanvasNav.on("click", "li a, .menu-expand", function (e) {
        var $this = $(this);

        if ($this.attr("href") === "#" || $this.hasClass("menu-expand")) {
          e.preventDefault();

          if ($this.siblings("ul:visible").length) {
            $this.parent("li").removeClass("active");
            $this.siblings("ul").slideUp();
            $this.parent("li").find("li").removeClass("active");
            $this.parent("li").find("ul:visible").slideUp();
          } else {
            $this.parent("li").addClass("active");
            $this
              .closest("li")
              .siblings("li")
              .removeClass("active")
              .find("li")
              .removeClass("active");
            $this.closest("li").siblings("li").find("ul:visible").slideUp();
            $this.siblings("ul").slideDown();
          }
        }
      });
    }

    mobileOffCanvasMenu();

    // Background Image
    $("[data-bg-img]").each(function () {
      console.log("bg-img",this)
      $(this).css("background-image", "url(" + $(this).data("bg-img") + ")");
    });
    // Background Color
    $("[data-bg-color]").each(function () {
      $(this).css("background-color", $(this).data("bg-color"));
    });

    // Fancybox Js
    $(".lightbox-image").fancybox();

    //Video Popup
    $(".play-video-popup").fancybox();

    // Datepicker
    $("#datepicker").datepicker();

  });


  // Scroll Top Hide Show
  $(window).on("scroll", function () {
    if ($(this).scrollTop() > 250) {
      $(".scroll-to-top").fadeIn();
    } else {
      $(".scroll-to-top").fadeOut();
    }

    // Sticky Header
    if ($(".sticky-header").length) {
      var windowpos = $(this).scrollTop();
      if (windowpos >= 150) {
        $(".sticky-header").addClass("sticky");
        $(".mobile-sticky").addClass("sticky");
        $(".sticky-img").attr("src", require("@/assets/img/logo-dark.png"));
      } else {
        $(".sticky-header").removeClass("sticky");
        $(".mobile-sticky").removeClass("sticky");
        $(".sticky-img").attr("src", require("@/assets/img/logo.png"));
      }
    }
  });

  //Scroll To Top
  $(".scroll-to-top").on("click", function () {
    $("html, body").animate({ scrollTop: 0 }, 800);
    return false;
  });


})(window.jQuery);



// WEBPACK FOOTER //
// ./src/assets/js/custom.js